<template>
  <div class="flex flex-row items-start gap-4">
    <v-swatches :model-value="modelValue" :swatches="swatches"
                data-testid="green-screen-color-swatches"
                popover-x="left"
                popover-y="top"
                row-length="6"
                shapes="circles"
                background-color="transparent"
                :wrapper-style="{ display: 'flex', flexDirection: 'row' }"
                inline
                show-border
                @update:model-value="emit('update:modelValue', $event)">
    </v-swatches>
    <div class="flex flex-col">
      <div class="flex overflow-hidden rounded-[10px] border-2 border-[#333940]">
        <div class="flex items-center justify-center bg-[#333940] px-4 py-2 text-white text-base">#</div>
        <input id="hex-input" v-model="hexInput" maxlength="6"
               class="text-white text-base py-2 px-3 w-28 outline-none focus:ring-0 bg-transparent"
               @input="onHexInput" @focus="onHexFocus" @blur="hexInput = ''" />
      </div>
      <span v-if="hexInput && !isValidHex('#' + hexInput)" class="text-red-400 text-xs mt-1">Invalid hex</span>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref } from 'vue';
import { VSwatches } from 'vue3-swatches';

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  swatches: {
    type: Array,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

// Only filled while the field is focused, so it never shows a color that has since been
// picked from the swatches.
const hexInput = ref('')

const isValidHex = (hex) => /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex)

const onHexInput = () => {
  const hexWithHash = '#' + hexInput.value
  if (isValidHex(hexWithHash)) {
    emit('update:modelValue', hexWithHash)
  }
}

const onHexFocus = () => {
  hexInput.value = props.modelValue.substring(1)
}
</script>
